module.exports = __webpack_public_path__ + "static/22_tat5-e07e7158f3a397ceff58396eb1c597e9.jpg";